import ApplicationAdapter from 'eflex/adapters/application';

export default class OracleDellBoomiBomSourceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'bomSources';
  }
}
